import { Box, Checkbox, FormControlLabel, Button, Grid, Typography, Tooltip, Icon, IconButton } from '@mui/material'
import { useState, useEffect, Dispatch, SetStateAction, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IOSSwitch } from '../../../../../../../components/dinamicForm/switch'
import { useStyles } from '../styles'
import { TabDepartment } from '../../../typing/enums'
import { Item } from '../../../../../../../utils/types/generals'
import { icons } from '../../../../../../../utils/icons'
import { Roles } from '../../../../../../../utils/enums'
import { removeAllReference } from '../../../../../../../utils/methods/removedReference'

const useTables = ({ setUserSelected, userSelected, dataFilter, filterRow, ...props }: {
  filterRow: ({ value, list }: {
    value: Record<string, unknown>;
    list: any[];
  }) => any[]; dataFilter: Record<string, unknown>; tab: string; userSelected: Record<string, boolean>; setUserSelected: Dispatch<SetStateAction<Record<string, boolean>>>, handleFolioSetting: (data?: Record<string, Item[]> | undefined) => void; userTable: { [x: string]: any }[]
}) => {
  const { t } = useTranslation()
  const styles = useStyles()
  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description: string
    id: string | number
    confirm?: () => void
  }>({
    id: '',
    open: false,
    title: '',
    description: '',
  })
  const [deleteSelected, setDeletedSelected] = useState<string[]>([])
  const [userFolioSelected, setUserFolioSelected] = useState<
    Record<
      string,
      {
        status: boolean
        reassignFolio?: boolean
        hierarchy?: boolean
        settings?: {
          users: Item[]
          usersTypes: Item[]
          stores: Item[]
        }
      }
    >
  >({})

  const handleSelectUser = ({ id, value, skipCondition }: { id: string; value: boolean; skipCondition?: boolean }) => {
    let userSelectedCopy = structuredClone(userSelected)

    if (!!userFolioSelected?.[id]?.settings && !skipCondition) {
      setOpenModal((prev) => ({
        ...prev,
        open: true,
        id,
        title: t('department.form.modal.deleteSettingsTitle'),
        description: t('department.form.modal.deleteSettingsDescription'),
      }))
    } else {
      if (!!value) {
        setUserFolioSelected((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            status: false,
          },
        }))

        userSelectedCopy = {
          ...userSelectedCopy,
          [id]: value,
        }
      } else {
        setUserFolioSelected((prev) => {
          const copyPrev = structuredClone(prev)
          delete copyPrev[id]
          return copyPrev
        })

        delete userSelectedCopy[id]
      }

      setUserSelected(userSelectedCopy)
    }
  }

  const setAllUsers = ({ newSelected, skip, filter, unmark }: { skip?: boolean; filter?: Record<string, any>[]; newSelected: Record<string, boolean>; unmark?: boolean }) => {
    const existSomeConfig = filter?.some((item) => !!userFolioSelected[item.id]?.settings)

    if (!!existSomeConfig && !skip) {
      setOpenModal((prev) => ({
        ...prev,
        open: true,
        id: 'all',
        title: t('department.form.modal.deleteSettingsTitle'),
        description: t('department.form.modal.deleteSettingsDescription'),
      }))
    } else {
      if (!!unmark) {
        setUserFolioSelected({})
      }
      setUserSelected(newSelected)
    }
  }

  const [openDrawer, setOpenDrawer] = useState<{
    setting: boolean
    user: {
      id: number | string
      name: string
      curp: string
    }
  }>({
    setting: false,
    user: {
      id: '',
      name: '',
      curp: '',
    },
  })

  const closeModal = () => {
    setOpenModal((prev) => ({
      ...prev,
      open: false,
      confirm: undefined
    }))
  }

  const handleSelect = ({ id, value, skipCondition, name = 'status' }: { id: string; value: boolean; skipCondition?: boolean, name?: 'reassignFolio' | 'status' }) => {
    if ((!!userFolioSelected?.[id]?.settings /* || !!userFolioSelected?.[id]?.hierarchy */) && !!value && !skipCondition) {
      setOpenModal((prev) => ({
        ...prev,
        open: true,
        id,
        title: t('department.form.modal.deleteSettingsTitle'),
        description: t('department.form.modal.deleteSettingsDescription'),
      }))
    } else {
      setUserFolioSelected((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          [name]: value,
          ...name == 'status' && { hierarchy: false }
        },
      }))
    }
  }

  const closeDrawer = () => {
    setOpenDrawer((prev) => ({
      ...prev,
      setting: false,
    }))
  }

  const handleOpenDrawer = ({
    user,
  }: {
    user: {
      id: number | string
      name: string
      curp: string
    }
  }) => {
    const userSelectedCopy = structuredClone(userFolioSelected)

    props.handleFolioSetting(userSelectedCopy?.[user.id]?.settings)

    setOpenDrawer((prev) => ({
      ...prev,
      setting: true,
      user,
    }))
  }

  const setSettings = ({
    settings,
    hierarchy,
    id,
  }: {
    id: string | number
    settings?: {
      users: Item[]
      usersTypes: Item[]
      stores: Item[]
    }
    hierarchy?: boolean
  }) => {
    setUserFolioSelected((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        hierarchy,
        settings,
      },
    }))
  }

  const [row, setRow] = useState<
    {
      id: number | string
      name: string
      curp: string
      role: number | string
      userType: number | string
    }[]
  >([])
  const getUsersThatCanManageFolios = () => {
    let newSelectedUser: Record<
      string,
      {
        status: boolean
        reassignFolio?: boolean
        settings?: {
          users: Item[]
          usersTypes: Item[]
          stores: Item[]
        }
      }
    > = structuredClone(userFolioSelected)

    const newRow: {
      id: number | string
      name: string
      curp: string
      role: number | string
      roleName: string
      userType: number | string
    }[] = []

    Object.entries(userSelected)?.forEach(([key, item]) => {
      const user = props?.userTable?.find((itemUsers) => itemUsers.id?.toString() == key)

      if (!!item && !!user) {
        if (newSelectedUser[key]?.reassignFolio === undefined) {
          newSelectedUser = {
            ...newSelectedUser,
            [key]: {
              ...newSelectedUser[key],
              reassignFolio: (user?.role === Roles.SUPERVISOR || user?.role == Roles.GERENT)
            },
          }
        }

        if (!newSelectedUser[key]) {
          newSelectedUser = {
            ...newSelectedUser,
            [key]: {
              ...newSelectedUser[key],
              status: false,
            },
          }
        } else {
          newSelectedUser = { ...newSelectedUser, [key]: newSelectedUser[key] }
        }

        newRow.push({
          curp: user?.curp ?? '',
          id: user?.id ?? '',
          name: user?.name ?? '',
          role: user?.role ?? '',
          roleName: user?.roleName ?? '',
          userType: user?.userType ?? '',
        })
      }
    })

    setRow(
      newRow?.sort((a) => {
        if (!!newSelectedUser?.[a.id]?.status) {
          return -1
        }
        return 1
      })
    )
    setUserFolioSelected(newSelectedUser)
  }

  const setAllSettingsFolioUser = (data: {
    skip?: boolean
    filter?: Record<string, any>[]
    userFolio: Record<
      string,
      {
        status: boolean
        settings?:
        | {
          users: Item[]
          usersTypes: Item[]
          stores: Item[]
        }
        | undefined
      }
    >
  }) => {
    const existSomeConfig = data?.filter?.some((item) => !!userFolioSelected[item.id]?.settings)

    if (!!existSomeConfig && !data.skip) {
      setOpenModal((prev) => ({
        ...prev,
        open: true,
        id: 'all',
        title: t('department.form.modal.deleteSettingsTitle'),
        description: t('department.form.modal.deleteSettingsDescription'),
      }))
    } else {
      setUserFolioSelected(data.userFolio)
    }
  }
  const rowFiltered = useMemo(() => filterRow({ list: row, value: dataFilter }), [row, dataFilter])

  const headersChecks = useMemo(() => {
    const userFolioSelectedCopy = removeAllReference(userFolioSelected)
    const hierarchy = rowFiltered.filter(item => !userFolioSelectedCopy?.[item.id]?.status)
    const reassignFolio = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.reassignFolio)
    const status = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.status)
    return {
      reassignFolio: !reassignFolio && rowFiltered?.length,
      status: !status && rowFiltered?.length,
      hierarchy: !hierarchy.some(item => !userFolioSelectedCopy?.[item.id]?.hierarchy) && !!hierarchy?.length
    }
  }, [userFolioSelected])

  const selectOrUnSelectAll = (payload?: { name: string; value: boolean }) => {
    const name = payload?.name
    let userFolioSelectedCopy = removeAllReference(userFolioSelected)
    if (name == 'status') {
      const existSomeConfig = rowFiltered?.some((item) => !!userFolioSelected[item.id]?.settings)

      if (payload?.value && existSomeConfig) {
        setOpenModal((prev) => ({
          ...prev,
          open: true,
          title: t('department.form.modal.deleteSettingsTitle'),
          description: t('department.form.modal.deleteSettingsDescription'),
          confirm: () => {
            rowFiltered.forEach(item => {
              delete userFolioSelectedCopy[item.id].settings
              userFolioSelectedCopy[item.id].hierarchy = false
              userFolioSelectedCopy[item.id].status = true
            })
            setUserFolioSelected(userFolioSelectedCopy)
            closeModal()
          }
        }))
        return
      }
      rowFiltered.forEach(row => {
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], status: !!payload?.value, hierarchy: false }
      })
    }
    if (name == 'reassignFolio') {
      rowFiltered.forEach(row => {
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], reassignFolio: !!payload?.value }
      })
    }
    if (name == 'hierarchy') {
      rowFiltered.forEach(row => {
        const currentUser = userFolioSelectedCopy[row.id]
        userFolioSelectedCopy[row.id] = { ...currentUser, hierarchy: !!payload?.value && !currentUser.status }
      })
    }
    setUserFolioSelected(userFolioSelectedCopy)
  }
  const deletedUsersSelecteds = (payload?: { id: string }) => {
    setOpenModal((prev) => ({
      ...prev,
      open: true,
      title: t('department.form.modal.deleteSettingsPermission', { count: payload?.id ? 1 : 0 }),
      description: t('department.form.modal.deletePermissionDescription'),
      confirm: () => {
        const selectUserCopy = removeAllReference(userSelected)
        const userFolioSelectedCopy = removeAllReference(userFolioSelected)

        if (payload?.id) {
          setRow(prev => prev.filter(item => item.id != payload.id))
          delete selectUserCopy[payload.id]
          delete userFolioSelectedCopy[payload.id]
          setUserSelected(selectUserCopy)
          setUserFolioSelected(userFolioSelectedCopy)
          setDeletedSelected(prev => prev.filter(item => item != payload.id))
          closeModal()
          return
        }
        setRow(prev => prev.filter(item => !deleteSelected.includes(item.id)))
        deleteSelected.forEach(item => {
          delete selectUserCopy[item]
          delete userFolioSelectedCopy[item]
        })
        setUserFolioSelected(userFolioSelectedCopy)
        setUserSelected(selectUserCopy)
        setDeletedSelected([])
        closeModal()
      }
    }))

  }

  const columnUser = [
    {
      id: 'name',
      label: t('general.tags.nameAndLastName'),
      sortable: true,
      minWidth: 100,
      column: () => {
        return (
          <Typography sx={styles.headetText}>
            {t('general.tags.nameAndLastName')} (Rol)
          </Typography>
        )
      },
      renderCell: (params: any) => {
        const row = params.row

        return (
          <Typography sx={styles.unitContent} className="w-full">
            {row.name} {!!row.roleName ? `(${row.roleName})` : ""}
          </Typography>
        )
      }
    },
    {
      id: 'curp',
      label: t('general.tags.curp'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'action',
      label: t('department.form.tabs.folio'),
      minWidth: 100,
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <FormControlLabel
              sx={styles.label}
              control={
                <IOSSwitch
                  name="notified"
                  checked={!!userSelected?.[params?.row?.id]}
                  onChange={({ target }) => {
                    const { checked } = target
                    handleSelectUser({ id: params?.row?.id, value: checked })
                  }}
                  sx={{ m: 1 }}
                />
              }
              label={t('department.form.table.switch')}
            />
          </Box>
        )
      },
    },
  ]

  const column = [
    {
      id: 'name',
      label: t('general.tags.nameAndLastName'),
      sortable: true,
      minWidth: 100,
      column: () => {
        return (
          <Typography sx={styles.headetText}>
            {t('general.tags.nameAndLastName')} (Rol)
            <br />
            {t('general.tags.curp')}
          </Typography>
        )
      },
      renderCell: (params: any) => {
        const user = params.current
        const curp = params.row?.curp

        return (
          <Box sx={styles.containerUnit}>
            {!!user || !!curp ? (
              <>
                {!!user && (
                  <Typography sx={styles.unitContent} className="w-full">
                    {user} {!!params.row?.roleName ? `(${params.row?.roleName})` : ""}
                  </Typography>
                )}

                {!!curp && (
                  <Typography sx={styles.user} className="w-full">
                    {curp}
                  </Typography>
                )}
              </>
            ) : (
              <Typography sx={styles.user} className="w-full">
                N/A
              </Typography>
            )}
          </Box>
        )
      },
    },
    {
      id: 'notified',
      label: t('department.form.tabs.notified'),
      minWidth: 50,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.status}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'status', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('department.form.tabs.notified')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="notified"
              checked={!!userFolioSelected?.[params?.row?.id]?.status}
              onChange={(_, check) => {
                handleSelect({ id: params?.row?.id, value: check })
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'hierarchy',
      label: t('department.form.tabs.hierarchy'),
      minWidth: 50,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.hierarchy}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'hierarchy', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('department.form.tabs.hierarchy')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="hierarchy"
              disabled={!!userFolioSelected?.[params?.row?.id]?.status}
              checked={!!userFolioSelected?.[params?.row?.id]?.hierarchy}
              onChange={(_, check) => {
                if (!userFolioSelected?.[params?.row?.id]?.status) {
                  handleSelect({ id: params?.row?.id, value: check, name: 'hierarchy', skipCondition: true })
                }
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'reassignFolio',
      label: t('department.form.tabs.reassignFolio'),
      minWidth: 50,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              name="delete"
              className='remove-m'
              checked={!!headersChecks.reassignFolio}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'reassignFolio', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('department.form.tabs.reassignFolio')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="reassignFolio"
              checked={!!userFolioSelected?.[params?.row?.id]?.reassignFolio}
              onChange={(_, check) => {
                handleSelect({ id: params?.row?.id, value: check, name: 'reassignFolio', skipCondition: true })
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'store',
      label: t('general.tags.store'),
      minWidth: 100,
      contentColumn: {
        justifyContent: 'center',
      },
      renderCell: (params: any) => {
        const stores = userFolioSelected?.[params?.row?.id]?.settings?.stores

        return !!stores?.length ? (
          <Grid container justifyContent="center" alignItems="center">
            <Grid sx={styles.users} item xl={10} lg={10} md={10} sm={10} xs={10}>
              <Typography sx={styles.bodyText}>{stores[0]?.label ?? ''}</Typography>
            </Grid>
            <Grid sx={styles.containerIconTooltip} item xl={2} lg={2} md={2} sm={2} xs={2}>
              <Tooltip
                title={
                  <>
                    <ul style={styles.ul}>
                      {stores?.map((el, index) => (
                        <li key={index}>
                          <Typography sx={styles.ulNull}>{el.label}</Typography>
                        </li>
                      ))}
                    </ul>
                  </>
                }
              >
                <Icon sx={styles.viewMore}>{icons('add')}</Icon>
              </Tooltip>
            </Grid>
          </Grid>
        ) : (
          <Typography sx={styles.bodyText}>{stores?.[0]?.label ?? 'N/A'}</Typography>
        )
      },
    },
    {
      id: 'user',
      label: t('general.tags.user'),
      minWidth: 100,
      contentColumn: {
        justifyContent: 'center',
      },
      renderCell: (params: any) => {
        const users = userFolioSelected?.[params?.row?.id]?.settings?.users

        return !!users?.length ? (
          <Grid container justifyContent="center" alignItems="center">
            <Grid sx={styles.users} item xl={10} lg={10} md={10} sm={10} xs={10}>
              <Typography sx={styles.bodyText}>{users[0]?.label ?? ''}</Typography>
            </Grid>
            <Grid sx={styles.containerIconTooltip} item xl={2} lg={2} md={2} sm={2} xs={2}>
              <Tooltip
                title={
                  <>
                    <ul style={styles.ul}>
                      {users?.map((el, index) => (
                        <li key={index}>
                          <Typography sx={styles.ulNull}>{el.label}</Typography>
                        </li>
                      ))}
                    </ul>
                  </>
                }
              >
                <Icon sx={styles.viewMore}>{icons('add')}</Icon>
              </Tooltip>
            </Grid>
          </Grid>
        ) : (
          <Typography sx={styles.bodyText}>{users?.[0]?.label ?? 'N/A'}</Typography>
        )
      },
    },
    {
      id: 'userType',
      label: t('general.tags.userType'),
      minWidth: 100,
      contentColumn: {
        justifyContent: 'center',
      },
      renderCell: (params: any) => {
        const userType = userFolioSelected?.[params?.row?.id]?.settings?.usersTypes

        return !!userType?.length ? (
          <Grid container justifyContent="center" alignItems="center">
            <Grid sx={styles.users} item xl={10} lg={10} md={10} sm={10} xs={10}>
              <Typography sx={styles.bodyText}>{userType[0]?.label ?? ''}</Typography>
            </Grid>
            <Grid sx={styles.containerIconTooltip} item xl={2} lg={2} md={2} sm={2} xs={2}>
              <Tooltip
                title={
                  <>
                    <ul style={styles.ul}>
                      {userType?.map((el, index) => (
                        <li key={index}>
                          <Typography sx={styles.ulNull}>{el.label}</Typography>
                        </li>
                      ))}
                    </ul>
                  </>
                }
              >
                <Icon sx={styles.viewMore}>{icons('add')}</Icon>
              </Tooltip>
            </Grid>
          </Grid>
        ) : (
          <Typography sx={styles.bodyText}>{userType?.[0]?.label ?? 'N/A'}</Typography>
        )
      },
    },
    {
      id: 'settings',
      label: t('department.form.tabs.settings'),
      minWidth: 50,
      contentColumn: {
        justifyContent: 'center',
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.setting}>
            <Tooltip title={t('department.form.table.delete')}>
              <IconButton
                className='delete'
                onClick={() => { deletedUsersSelecteds({ id: params?.row?.id }) }}
              >
                {icons('delete')}
              </IconButton>
            </Tooltip>

            <Tooltip title={t('department.form.table.setting')}>
              <IconButton
                disabled={!!userFolioSelected?.[params?.row?.id]?.status}
                onClick={() => {
                  if (!userFolioSelected?.[params?.row?.id]?.status) {
                    handleOpenDrawer({
                      user: {
                        id: params?.row?.id,
                        curp: params?.row?.curp,
                        name: params?.row?.name,
                      },
                    })
                  }
                }}
              >
                {icons('setting')}
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
    },
  ]

  useEffect(() => {
    if (props.tab === TabDepartment.FOLIO) {
      getUsersThatCanManageFolios()
    }
    //eslint-disable-next-line
  }, [props?.tab])

  return { userSelected, rowFiltered, columnUser, row, column, openDrawer, openModal, userFolioSelected, deleteSelected, deletedUsersSelecteds, setDeletedSelected, setUserSelected, closeDrawer, setSettings, closeModal, handleSelect, handleOpenDrawer, setAllUsers, handleSelectUser, setAllSettingsFolioUser }
}

export { useTables }
